import React, { useContext, useState, useEffect, useRef } from 'react';
import { FormContext } from '../../context/FormContext';
import Input from "../CustomInput";
import { FaUserCircle } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const Step6 = ({ nextStep, prevStep }) => {
  const { formData, updateFormData } = useContext(FormContext);
  const [contact, setContact] = useState(formData.administrationContact || {});
  const [errors, setErrors] = useState({});
  const stepTitleRef = useRef(null);

  useEffect(() => {
    if (stepTitleRef.current) {
      stepTitleRef.current.focus();
    }
  }, []);

  useEffect(() => {
    setContact(formData.administrationContact || {});
  }, [formData.administrationContact]);

  const handleChange = (field, value) => {
    setContact(prev => ({ ...prev, [field]: value }));
  };

  const handlePhoneFocus = () => {
    setErrors(prev => ({ ...prev, mobilePhone: '' }));
  };

  const handleNext = () => {
    // Validação dos campos obrigatórios
    if (!contact.firstName || !contact.email || !contact.lastName || !contact.mobilePhone) {
      setErrors({
        firstName: !contact.firstName ? 'Primeiro Nome é obrigatório' : '',
        lastName: !contact.lastName ? 'Último Nome é obrigatório' : '',
        email: !contact.email ? 'Email é obrigatório' : '',
        mobilePhone: !contact.mobilePhone ? 'Celular é obrigatório' : '',
      });
      return;
    }

    // Normalizar email
    contact.email = (contact.email || '').trim().toLowerCase();

    // Validação do formato do email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(contact.email)) {
      setErrors(prev => ({ ...prev, email: 'Formato de email inválido (_@_._)' }));
      return;
    }

    if (contact.mobilePhone) {
      const e164Regex = /^\+[1-9]\d{1,14}$/;
      contact.mobilePhone = contact.mobilePhone.replace(/\s+/g, '');
      if (!e164Regex.test(contact.mobilePhone)) {
        setErrors(prev => ({
          ...prev,
          mobilePhone: 'Formato de celular inválido (padrão E.164 esperado).'
        }));
        return;
      }
    }
    
    updateFormData({ administrationContact: contact });
    nextStep();
  };

  return (
    <div>
      <h2 
        ref={stepTitleRef}
        tabIndex="-1"
        className="text-xl text-white font-bold mb-4 focus:outline-none"
      >
        6º Passo: Contato Administrador do Sistema
      </h2>      
      <div className="mb-4">
        <Input
          type="text"
          value={contact?.firstName}
          onChange={(e) => handleChange('firstName', e.target.value)}
          label="Primeiro Nome"
          icon={<FaUserCircle className="size-4" />}
          error={errors.firstName}
        />
      </div>
      <div className="mb-4">
        <Input
          type="text"
          value={contact?.lastName}
          onChange={(e) => handleChange('lastName', e.target.value)}
          label="Último Nome"
          icon={<FaUserCircle className="size-4" />}
          error={errors.lastName}
        />
      </div>
      <div className="mb-4">
        <Input
          type="email"
          value={contact?.email}
          onChange={(e) => handleChange('email', e.target.value)}
          label="Email"
          icon={<IoMdMail className="size-4" />}
          error={errors.email}
        />
      </div>
      <div className="mb-4">
        <label className="mb-2 block text-sm font-medium leading-6 text-[#f4f4f4]">
          Celular
        </label>
        <PhoneInput
          defaultCountry="br"
          value={contact?.mobilePhone}
          onChange={(phone) => handleChange('mobilePhone', phone)}
          onFocus={handlePhoneFocus}
        />
        {errors.mobilePhone && (
          <p className="mt-2 text-sm text-red-600">{errors.mobilePhone}</p>
        )}
      </div>

      <div className="flex justify-between gap-2">
        <button
          onClick={prevStep}
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 flex items-center gap-2 w-full justify-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          Voltar
        </button>
        <button
          onClick={handleNext}
          className="w-full flex justify-center items-center gap-x-2 rounded-md bg-[#0d6efd] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Seguinte
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Step6;
